import React from 'react';
import { cn } from '@/lib/utils';
import { TaskReportSectionProps } from './types';

const TaskReportSection: React.FC<TaskReportSectionProps> = ({
  title,
  description,
  className = '',
  children,
}) => {
  if (!title || !description) {
    console.warn('TaskReportSection: title and description are required');
    return null;
  }

  return (
    <section
      className={cn('text-center py-6', className)}
      aria-labelledby={`section-title-${title.replace(/\s+/g, '-').toLowerCase()}`}
    >
      <h3
        id={`section-title-${title.replace(/\s+/g, '-').toLowerCase()}`}
        className="text-md font-semibold text-gray-800 mb-2"
      >
        {title}
      </h3>
      <div className="flex justify-center items-center my-4 h-24">
        {children}
      </div>
      <p className="text-sm text-gray-500 max-w-xs mx-auto">{description}</p>
    </section>
  );
};

TaskReportSection.displayName = 'TaskReportSection';

export { TaskReportSection };
